import { useEffect, useState } from "react";
import { onIdTokenChanged } from "firebase/auth";
import { auth } from "../firebase";
import { isIosCapacitor } from "../utils/nativeHttp";
import { getManualAuth, isManualAuthLikelyValid } from "../utils/manualAuth";

// Menu visibility only. Every protected operation still requires server authorization.
export function canShowPlatformAdmin(claims) {
  return Boolean(claims?.sub && claims.email_verified === true &&
    String(claims.email || "").trim().toLowerCase() === "juanquiros151@gmail.com");
}

export default function useMenuAdminAccess() {
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    let generation = 0;
    const refresh = async () => {
      const request = ++generation;
      setAllowed(false);
      try {
        let claims = null;
        if (auth.currentUser) claims = (await auth.currentUser.getIdTokenResult()).claims;
        else if (isIosCapacitor()) {
          const session = getManualAuth();
          if (session && isManualAuthLikelyValid(session)) {
            const encoded = session.idToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
            claims = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, "=")));
            if (claims.sub !== session.uid || Number(claims.exp) * 1000 <= Date.now()) claims = null;
          }
        }
        if (request === generation) setAllowed(canShowPlatformAdmin(claims));
      } catch (_) { /* Remain hidden until the authenticated identity is available. */ }
    };
    const unsubscribe = onIdTokenChanged(auth, refresh);
    window.addEventListener("manual-auth-changed", refresh);
    window.addEventListener("manual-auth-detected", refresh);
    return () => {
      generation++;
      unsubscribe();
      window.removeEventListener("manual-auth-changed", refresh);
      window.removeEventListener("manual-auth-detected", refresh);
    };
  }, []);
  return allowed;
}
